import _ from "lodash";
import { useState } from "react";

import FormatISODateTime from "../../../../global/FormatISODateTime";
import HNSColors from "../../../../ui library/HNSColors";
import { useAISummaryStore } from "../../store/aiSummaryStore";
import { STRINGS } from "../../utils/strings";

import AvatarIcon from "./AvatarIcon";
import CallInfo from "./CallInfo";
import ParticipantInfo from "./ParticipantInfo";

export default function CallSummaryListItem({ data, handleClick }) {
  const { selectedSummaryNote } = useAISummaryStore();

  const clientName = data?.clientName ?? STRINGS.UNKNOWN;
  const callLog = data?.callLog ?? {};
  const caller = callLog?.caller ?? {};
  const receiver = callLog?.receiver ?? {};

  const callerName = caller.name ? _.startCase(_.toLower(caller.name)) : STRINGS.UNKNOWN;
  const callerPhone = caller.phone ?? STRINGS.UNKNOWN;
  const receiverName = receiver.name ? _.startCase(_.toLower(receiver.name)) : STRINGS.UNKNOWN;
  const receiverPhone = receiver.phone ?? STRINGS.UNKNOWN;

  const [startDate, startTime] = (FormatISODateTime(callLog.startTime, "", "-") ?? STRINGS.UNKNOWN)
    .split("-")
    .map((x) => x.trim());
  const [endDate, endTime] = (FormatISODateTime(callLog.endTime, "", "-") ?? STRINGS.UNKNOWN)
    .split("-")
    .map((x) => x.trim());

  const isSelected = selectedSummaryNote && _.isEqual(data, selectedSummaryNote);
  const readTime = data?.readTime;

  const [isHovered, setIsHovered] = useState(false);

  const getBackgroundColor = () => {
    if (isHovered && !isSelected) {
      return HNSColors.tertiary[950];
    }

    if (isSelected && readTime) {
      return HNSColors.tertiary[900];
    }

    if (isSelected) {
      return HNSColors.secondary[900];
    }

    return HNSColors.tertiary[975];
  };

  return (
    <div
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="relative flex cursor-pointer flex-col gap-4 rounded-[8px] px-[18px] py-[16px] transition-all"
      style={{ backgroundColor: getBackgroundColor() }}
    >
      <div
        className="absolute left-0 top-0 h-full w-[7px] rounded-l-[8px]"
        style={{ backgroundColor: readTime ? HNSColors.tertiary[500] : HNSColors.secondary[700] }}
      />
      <div className="flex w-full flex-row gap-4">
        <AvatarIcon isNotCopiedSelected={isSelected && !readTime} />
        <CallInfo
          startDate={startDate}
          startTime={startTime}
          endTime={endTime}
          clientName={clientName}
        />
      </div>

      <div className="flex flex-col gap-2">
        <ParticipantInfo label="Caller" name={callerName} phone={callerPhone} />
        <ParticipantInfo label="Receiver" name={receiverName} phone={receiverPhone} />
      </div>
    </div>
  );
}
